import React, { useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputCompo } from '../../../Components/InputCompo/InputCompo';
import CloseIcon from '@mui/icons-material/Close';
import ButtonComp from '../../../Components/ButtonComp/ButtonComp';
import { useNavigate, useLocation } from 'react-router-dom';

const SearchBox = ({ clearButtonRef, searchKey, setSearchKey, setTempSearch, TempSearch }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onChange = (e) => {
    e.preventDefault();
    clearButtonRef.current?.click();
    const { value } = e.target;
    setTempSearch(value);
  };

  const CallSearch = () => {
    const query = encodeURIComponent(TempSearch.trim());
    navigate(`/search?query=${query}`, { replace: true }); // Update URL without refreshing
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default behavior
      CallSearch(); // Trigger search
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('query');
    setTempSearch(query || ''); // Set TempSearch based on URL query
  }, [location.search, setTempSearch]);

  return (
    <div className="flex">
      <div className="flex items-center border-3 border-[#004878] max-md:w-[100%] w-[600px] gap-[10px] rounded-xl rounded-r-none px-[10px] py-[5px]">
        <InputCompo
          placeholder="Enter organisation name or GSN/PAN/Darpan ID/FCRA Number"
          className="border-none bg-transparent w-[100%] h-[100%] text-md"
          value={TempSearch || ''}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
        {TempSearch ? (
          <div
            className="rounded-full px-[15px] duration-[2s] delay-75 ease-in cursor-pointer bg-[#ED1C24]"
            onClick={() => {
              setSearchKey('');
              setTempSearch('');
              navigate('/search', { replace: true }); // Clear query parameter
            }}
          >
            <CloseIcon className="text-white" />
          </div>
        ) : (
          <SearchIcon id="iconSize40px" className="text-gray-500 h-[30px] w-[30px] text-[40px]" />
        )}
      </div>
      <ButtonComp
        onClick={CallSearch}
        className="rounded-xl bg-[#004878] px-[30px] border-l-transparent rounded-l-none border-2 border-[#004878] text-white"
        text="Search"
      />
    </div>
  );
};

export default SearchBox;
